// Import statements
import React, { FC, useRef, useState } from "react";
import UserList from "../userlist/Userlist";

// Interface definitions

// Constants

// Helper functions

// Component
const App: FC = () => {
  // useState hooks

  // useRef hooks

  // Functions

  // useEffect hooks

  // Data processing

  // Conditional values

  // Component return
  return (
    <>
      <nav
        className="navbar is-brand"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand">
          <a className="navbar-item" href="https://bulma.io">
            <img
              src="https://bulma.io/assets/images/made-with-bulma.png"
              alt="Made with Bulma"
              width="128"
              height="24"
            />
          </a>
          <a
            role="button"
            className="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div id="navbarBasicExample" className="navbar-menu">
          <div className="navbar-start">
            <a className="navbar-item">Home</a>

            {/* <a className="navbar-item">Documentation</a>

            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-link">More</a>

              <div className="navbar-dropdown">
                <a className="navbar-item">About</a>
                <a className="navbar-item is-selected">Jobs</a>
                <a className="navbar-item">Contact</a>
                <hr className="navbar-divider" />
                <a className="navbar-item">Report an issue</a>
              </div>
            </div> */}
          </div>

          <div className="navbar-end">
            <div className="navbar-item">
              <div className="buttons">
                <a className="button is-primary">
                  <strong>Sign up</strong>
                </a>
                <a className="button is-light">Log in</a>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div className="container">
        <div className="content">
          <h1 className="title is-1 is-spaced">Velkommen til Teamgym Manager</h1>
          <h2>Træn gymnaster, udtag holdet og sæt taktikken</h2>
          <p>
            Teamgym består af 3 gymnastiske dicipliner, rytmisk serie for hele holdet, spring på fiberbane samt spring på trampet.
          </p>
          <UserList />
        </div>
      </div>
    </>
  );
};
// Component export
export default App;

// Import statements
// Interface definitions
// Constants
// Helper functions
// Component
// useState hooks
// useRef hooks
// Functions
// useEffect hooks
// Data processing
// Conditional values
// Component return
// Component export
